<template>
  <div style="background-color:white">
    <el-row style="padding-top:10px">
      <el-col :span="24">
        <el-button size="small" class="btn" v-if="show.sh" type="primary" @click="handleCreate">调拨审核</el-button>
        <!-- <el-button size="small" type="primary" disabled="true" class="btn">导出列表</el-button> -->
        <el-form :inline="true" ref="deviceInfo" :model="deviceInfo" class="demo-form-inline"
          style="float:right!important">
          <el-form-item :label="lable.drdw">
            <el-cascader
              v-model="deviceInfo.transferIn"
              style="width: 140px"
              :options="options"
              :props="props"
              clearable
              :show-all-levels="false"
              filterable
              :placeholder="'请选择' + lable.drdw"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="日期">
            <el-date-picker v-model="deviceInfo.date" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="模糊搜索">
            <el-input v-model="deviceInfo.content" auto-complete="off" placeholder="请输入搜索内容"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="findAllClick">查询</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
          :cell-style="{ textAlign: 'center' }" ref="multipleTable" :data="allocationData" tooltip-effect="dark"
          style="width: 100%;text-align: center" stripe>
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column prop="id" :label="lable.id" width="180">
            <template slot-scope="scope" show-overflow-tooltip>
              <el-link :underline="false" @click="onClick(scope.row)" style="color: #4095E5;text-decoration: none;">
                {{ scope.row.id }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column prop="sqrq" :label="lable.sqrq" :formatter="formateTime" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="drdw" :label="lable.drdw" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="dcdw" :label="lable.dcdw" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="userName" :label="lable.userName" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="dbly" :label="lable.dbly" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="statue" :label="lable.statue" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.statue == '4'" style="color:#4095E5">待审核</span>
            </template>
          </el-table-column>
          <el-table-column :label="lable.cz" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button @click="selectClick(scope.row)" type="text" size="small">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <!--分页工具条-->
      <el-col :span="24" class="toolbar" style="margin-top:5px;height: 35px;">
        <el-pagination v-if="allocationData.length > 0" @size-change="handleSizeChange"
          @current-change="handleCurrentChange" :page-sizes="[10, 20, 50, 100]" :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:right">
        </el-pagination>
      </el-col>
    </el-row>

    <!--------------------------------------------------------------------调拨审核弹框--------------------------------------------------------------------------------->
    <el-dialog :visible.sync="dialogFormVisible" title="调拨审核" :close-on-click-modal="false"
      :close-on-press-escape="false" :before-close="handleClose"
      style="width:100% !important;margin-left: 100px;">
      <el-form :model="questionForm" ref="dataForm" label-position="left" label-width="100px"
        style="width: 90%; margin-left:40px;">
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.dcdw" style="width:90%">
              <el-input v-model="questionForm.dcdw" :readonly="true" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.drdw">
              <el-input v-model="questionForm.drdw" :readonly="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.userName" style="width:90%">
              <el-input v-model="questionForm.userName" :readonly="true" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="申请部门">
              <el-input v-model="questionForm.companyName" :readonly="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.sqrq" style="width:90%">
              <el-input v-model="questionForm.sqrq" :readonly="true" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.state">
              <el-input :readonly="true" v-model="questionForm.wz" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="lable.dbly" prop="dbly">
          <el-input type="textarea" :rows="2" :readonly="true" v-model="questionForm.dbly" />
        </el-form-item>
        <el-form-item label="审核意见" prop="shyj">
          <el-input placeholder="请输入审核意见" v-model="questionForm.shyj" />
        </el-form-item>
        <el-form-item label="资产列表">
          <el-table :data="assetsData" :border="true" style="width: 100%;text-align: center" size="mini"
            max-height="235px" :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
            :cell-style="{ textAlign: 'center' }">
            <el-table-column prop="glbh" label="管理编号" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="zcbh" label="资产编号" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="zcmc" label="资产名称" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="id" v-if="false"> </el-table-column>
            <el-table-column prop="sbxh" label="规格型号" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="ssdw" label="所属单位" show-overflow-tooltip>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="附加资料">
          <el-table :data="fileData" :border="true" style="width: 100%;text-align: center" size="mini" max-height="235px"
            :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }" :cell-style="{ textAlign: 'center' }">
            <el-table-column label="序号" type="index" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="name" label="资料名称" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="id" v-if="false"> </el-table-column>
            <el-table-column prop="createTime" label="上传日期" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="fileDesc" label="备注" show-overflow-tooltip>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="200px">
              <template slot-scope="scope">
                <el-button @click="yulan(scope.row)" type="text" size="small">预览</el-button>
                <el-button type="text" size="small" @click="downloading(scope.row)">下载</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button style="margin-left: 10px;" type="primary" @click="adopt">通过</el-button>
        <el-button type="danger" @click="reject">驳回</el-button>
        <el-button @click="cancel">取消</el-button>

      </div>
    </el-dialog>

    <!--------------------------------------------------------------------调入审核弹框--------------------------------------------------------------------------------->
    <el-dialog :visible.sync="dialogFormVisible4" title="调入审核" :close-on-click-modal="false"
      :close-on-press-escape="false" :before-close="handleClose"
      style="width:100% !important;margin-left: 100px;">
      <el-form :model="questionForm" ref="dataForm" label-position="left" label-width="100px"
        style="width: 90%; margin-left:40px;">
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.drdw" style="width:90%">
              <el-input v-model="questionForm.drdw" :readonly="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.userName" style="width:90%">
              <el-input v-model="questionForm.userName" :readonly="true" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="申请部门">
              <el-input v-model="questionForm.companyName" :readonly="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.sqrq" style="width:90%">
              <el-input v-model="questionForm.sqrq" :readonly="true" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.statue">
              <el-input :readonly="true" v-model="questionForm.wz" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="lable.dbly" prop="dbly">
          <el-input type="textarea" :rows="2" :readonly="true" v-model="questionForm.dbly" />
        </el-form-item>
        <el-form-item label="审核意见" prop="shyj">
          <el-input placeholder="请输入审核意见" v-model="questionForm.shyj" />
        </el-form-item>
        <el-form-item label="需求列表">
          <el-table :data="transfersData" :border="true" style="width: 100%" size="mini" max-height="235px"
            :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }" :cell-style="{ textAlign: 'center' }">
            <el-table-column prop="deviceTypeName" label="资产分类" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="sl" label="数量" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="lc" label="量程" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="jddj" label="精度等级" show-overflow-tooltip>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="附加资料">
          <el-table :data="fileData" :border="true" style="width: 100%;text-align: center" size="mini" max-height="235px"
            :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }" :cell-style="{ textAlign: 'center' }">
            <el-table-column label="序号" type="index" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="name" label="资料名称" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="createTime" label="上传日期" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="fileDesc" label="备注" show-overflow-tooltip>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="200px">
              <template slot-scope="scope">
                <el-button @click="yulan(scope.row)" type="text" size="small">预览</el-button>
                <el-button type="text" size="small" @click="downloading(scope.row)">下载</el-button>

              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button style="margin-left: 10px;" type="primary" @click="adopt">通过</el-button>
        <el-button type="danger" @click="reject">驳回</el-button>
        <el-button @click="cancel">取消</el-button>

      </div>
    </el-dialog>
    <!--------------------------------------------------------------------调拨批量审核弹框--------------------------------------------------------------------------------->
    <!-- <el-dialog :visible.sync="dialogFormVisible1" :close-on-click-modal='false' title="批量调拨审核"
      style="width:100% !important;margin-left: 80px;">
      <el-form :model="questionForm" ref="dataForm" label-position="left" label-width="100px"
        style="width: 90%; margin-left:5%;">
        <el-form-item label="审核意见" prop="shyj">
          <el-input placeholder="请输入审核意见" v-model="questionForm.shyj" />
        </el-form-item>
        <el-form-item label="审核结果" prop="shyj">
          <el-input placeholder="请输入审核结果" v-model="questionForm.shjg" />
        </el-form-item>

        <el-form-item label="资产列表" prop="correctAnswer">
          <el-table :data="tableData" :border="true" style="width: 100%;text-align: center" size="mini" max-height="235px"
          :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }" :cell-style="{ textAlign: 'center' }">
            <el-table-column prop="id" label="申请单号" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="dcdw" label="调出试验室" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="drdw" label="调入试验室" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="sqrq" label="申请日期" show-overflow-tooltip>
            </el-table-column>
            <el-table-column fixed="right" label="操作" show-overflow-tooltip>
              <template slot-scope="scope">
                <el-button @click="handleClick(scope.row)" type="text">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button style="margin-left: 10px;" type="primary" @click="adopt1">通过</el-button>
        <el-button type="danger" @click="reject1">驳回</el-button>
        <el-button @click="dialogFormVisible1 = false">取消</el-button>
      </div>
    </el-dialog> -->
    <!--------------------------------------------------------------------调拨详情弹框--------------------------------------------------------------------------------->
    <el-dialog :visible.sync="dialogFormVisible2" title="调拨详情" :close-on-click-modal="false"
      :close-on-press-escape="false"
      style="width:100% !important;margin-left: 100px;">
      <el-form :model="questionForm" ref="dataForm" label-position="left" label-width="100px"
        style="width: 90%; margin-left:40px;">
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.dcdw" style="width:90%">
              <el-input v-model="questionForm.dcdw" :readonly="true" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.drdw">
              <el-input v-model="questionForm.drdw" :readonly="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.userName" style="width:90%">
              <el-input v-model="questionForm.userName" :readonly="true" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="申请部门">
              <el-input v-model="questionForm.companyName" :readonly="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.sqrq" style="width:90%">
              <el-input v-model="questionForm.sqrq" :readonly="true" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.statue">
              <el-input :readonly="true" v-model="questionForm.wz" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="审核结果" style="width:90%">
              <el-input :readonly="true" v-model="questionForm.shjg" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="审核意见">
              <el-input :readonly="true" v-model="questionForm.shyj" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="lable.dbly" prop="dbly">
          <el-input type="textarea" :rows="2" :readonly="true" v-model="questionForm.dbly" />
        </el-form-item>
        <el-form-item label="资产列表" v-if="Dshow">
          <el-table :data="transfersData" :border="true" style="width: 100%;" size="mini" max-height="235px"
            :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }" :cell-style="{ textAlign: 'center' }">
            <el-table-column prop="deviceTypeName" label="资产分类" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="id" v-if="false"></el-table-column>
            <el-table-column prop="sl" label="数量" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="lc" label="量程" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="jddj" label="精度等级" show-overflow-tooltip>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="资产列表" v-if="Dshow1">
          <el-table :data="assetsData" :border="true" style="width: 100%;text-align: center" size="mini"
            max-height="235px" :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
            :cell-style="{ textAlign: 'center' }">
            <el-table-column prop="glbh" label="管理编号" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="zcbh" label="资产编号" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="zcmc" label="资产名称" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="sbxh" label="规格型号" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="ssdw" label="所属单位" show-overflow-tooltip>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="附加资料">
          <el-table :data="fileData" :border="true" style="width: 100%;text-align: center" size="mini" max-height="235px"
            :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }" :cell-style="{ textAlign: 'center' }">
            <el-table-column label="序号" type="index" show-overflow-tooltip >
            </el-table-column>
            <el-table-column prop="name" label="资料名称" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="id" v-if="false"> </el-table-column>
            <el-table-column prop="createTime" label="上传日期" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="fileDesc" label="备注" show-overflow-tooltip>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="200px">
              <template slot-scope="scope">
                <el-button @click="yulan(scope.row)" type="text" size="small">预览</el-button>
                <el-button type="text" size="small" @click="downloading(scope.row)">下载</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button style="margin-left: 10px;" type="primary" @click="dialogFormVisible2 = false">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="previewTitle" :visible.sync="docxdialog" style="margin-top:-50px" width="63%">
      <FilePreview ref="filePreview" />
    </el-dialog>
  </div>
</template>

<script >
import {
  findTransferAllocation,
  treeCompany,
  findByUserIdCompanyTree,
  findByIdFile,
  delByIdFile,
  findByIdAllocation,
  findByIdDevice,
  findTransferIn,
  examineAllocation,
  findByModule
} from "../../api/api";
import FilePreview from '../../components/preview/FilePreview.vue'

export default {
  name: "Transfer",
  components: {
    "FilePreview": FilePreview,
  },
  data() {
    return {
      show: {
        sh: false
      },
      Dshow: false,
      Dshow1: true,
      deviceInfo: {
        date: [],
        content: "",
        state: "",
        transferIn: "",
        transferOut: ""
      },
      lable: {},
      docxdialog: false,
      previewTitle: '',
      total: 0,
      pageIndex: 1,
      pagesize: 10,
      data: [],
      transfersData: [],
      allocationData: [],
      assetsData: [
        // 虚拟数据 后续调组件替换
      ],
      props: {
        label: "companyName",
        value: "companyCode",
        children: "zcompany",
        emitPath: false,
        checkStrictly: true,
      },
      multipleTable: [],
      options: [],
      questionForm: {
        transferId: [],
        deviceId: [],
        dblx: ""
      },
      docxdialog: false,
      previewTitle: '',
      innerVisible: false,
      dialogFormVisible: false,
      dialogFormVisible1: false,
      dialogFormVisible2: false,
      dialogFormVisible3: false,
      dialogFormVisible4: false,
      fileData: [],
      tableData: []
    };
  },
  methods: {
    //关闭页面执行函数
    handleClose(done) {
      this.findAll();
      done();
    },
    cancel() {
      this.dialogFormVisible1 = false;
      this.dialogFormVisible = false;
      this.dialogFormVisible4 = false;
      this.findAll();
    },
    downloading(scop) {
      // debugger
      this.downloadUtil.downloadFile(scop.path, scop.name);
    },
    //预览
    yulan(row) {
      if (row.path.substring(row.path.lastIndexOf(".") + 1) == 'jpg' || row.path.substring(row.path.lastIndexOf(".") + 1) == 'png' || row.path.substring(row.path.lastIndexOf(".") + 1) == 'jpeg') {
        this.previewTitle = "图片预览"
      } else {
        this.previewTitle = "文件预览"
      }
      this.docxdialog = true
      this.$nextTick(() => {
        this.$refs.filePreview.showView(row.path)
      })
    },
    onClick(row) {
      if (this.show.sh) {
        this.questionForm = row;
        this.findByIdfile(this.questionForm.id);
        if (this.questionForm.dblx == 2) {
          this.dialogFormVisible4 = true;
          this.findTransfer(this.questionForm.id);
        } else {
          this.dialogFormVisible = true;
          this.findByDevice(this.questionForm.id);
        }
      } else {
        this.$message.warning("你不具有审批权限")
      }

    },
    selectClick(row) {
      this.findByIdfile(row.id);
      if (row.dblx != 2) {
        this.findByDevice(row.id);
        this.Dshow = false
        this.Dshow1 = true
      } else {
        this.Dshow = true
        this.Dshow1 = false
        this.findTransfer(row.id);
      }
      this.questionForm = row;
      this.dialogFormVisible2 = true;
    },


    handleClick(row) {
    },
    //审批通过条件构造
    adopt() {
      let list = {
        shjg: "通过",
        shyj: this.questionForm.shyj,
        id: [this.questionForm.id],
        sout: "0",
        dblx: this.questionForm.dblx,
        drdw: this.questionForm.drdw
      };
      this.approval(list)
    },
    //审批驳回条件构造
    reject() {
      let list1 = {
        shjg: "驳回",
        shyj: this.questionForm.shyj,
        id: [this.questionForm.id],
        sout: "1",
        dblx: this.questionForm.dblx,
        drdw: this.questionForm.drdw
      };
      this.approval(list1)
    },
    //批量审批通过条件构造
    // adopt1() {
    //   var id1 = [];
    //   for (let s1 = 0; s1 < this.tableData.length; s1++) {
    //     id1.push(this.tableData[s1].id)
    //   }
    //   let list2 = {
    //     shjg: "通过",
    //     shyj: this.questionForm.shyj,
    //     id: id1,
    //     sout: "0"
    //   };
    //   this.approval(list2)
    // },
    //批量审批驳回条件构造
    // reject1() {
    //   var id2 = [];
    //   for (let s1 = 0; s1 < this.tableData.length; s1++) {
    //     id2.push(this.tableData[s1].id)
    //   }
    //   let list3 = {
    //     shjg: "驳回",
    //     shyj: this.questionForm.shyj,
    //     id: id2,
    //     sout: "1"
    //   };
    //   this.approval(list3)
    // },
    approval(row) {
      var userinfo = JSON.parse(localStorage.getItem("user"))
      var map = row;
      map.userId = userinfo.userId
      examineAllocation(map).then(datas => {
        // debugger
        let { status, message } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error"
          });
        } else if (status == 200) {
          this.cancel()
          this.$message({
            message: "审核完成",
            type: "success"
          });
        } else {
          this.$message({
            message: "请求错误",
            type: "error"
          });
        }
      });
    },
    findAllClick(){
      this.pageIndex=1
      this.findAll()
    },
    handleCreate() {
      let currentSelect = this.$refs.multipleTable.selection;
      if (currentSelect.length > 1) {
        this.$message.error('只能选择一条信息！ ')  // .....失败信息
      } else if (currentSelect.length == 1) {
        this.questionForm = currentSelect[0];
        this.findByIdfile(this.questionForm.id);
        if (this.questionForm.dblx == 2) {
          this.dialogFormVisible4 = true;

          this.findTransfer(this.questionForm.id);
        } else {
          this.dialogFormVisible = true;
          this.findByDevice(this.questionForm.id);
        }
      } else {
        this.$message.error('请选择需要审核信息')  // .....失败信息
      }
    },
    //根据单号查询调拨设备
    findByDevice(row) {
      findByIdDevice(row).then(datas => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          this.assetsData = data;
        }
      });
    },
    // 格式化时间显示到日期
    formateTime(row) {
      let nowData = new Date(row.sqrq)
      let year = nowData.getFullYear();
      let month = (nowData.getMonth() + 1).toString().padStart(2, '0');
      let date = nowData.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${date}`;
    },
    //调拨详情
    findById(row) {
      findByIdAllocation(row).then(datas => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          this.questionForm = data;
        }
      });
    },
    //删除检定附件信息
    DFile(row) {
      delByIdFile(row.id).then(datas => {
        let { status, message } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error"
          });
        } else if (status == 200) {
          this.findByIdfile(this.questionForm.id);
          this.$message({
            message: message,
            type: "success"
          });
        } else {
          this.$message({
            message: "请求错误",
            type: "error"
          });
        }
      });
    },
    //根据id查找文件
    findByIdfile(id) {
      findByIdFile(id).then(datas => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.fileData = data;
        }
      });
    },
    //根据id查找申请调入设备信息
    findTransfer(id) {
      findTransferIn(id).then(datas => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          this.transfersData = data;
        }
      });
    },
    //查找所有调拨信息
    findAll() {
      var userinfo = JSON.parse(localStorage.getItem('user'))
      let map = {
        start: this.deviceInfo.date == null ? null : this.deviceInfo.date[0],
        end: this.deviceInfo.date == null ? null : this.deviceInfo.date[1],
        content: this.deviceInfo.content,
        state: 4,
        transferIn: this.deviceInfo.transferIn,
        transferOut: this.deviceInfo.transferOut,
        userId: userinfo.userId
      };
      findTransferAllocation(map).then(datas => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          if (data == null) { this.data = [] } else { this.data = data; }
          this.allocationData = this.data.slice(
            (this.pageIndex - 1) * this.pagesize,
            this.pageIndex * this.pagesize
          );
          this.total = this.data.length;
        }
      });
    },
    getCompanyTree() {
      var userinfo = JSON.parse(localStorage.getItem("user"));
      var companyCode = "-1";
      if (
        userinfo.userRole == 1 ||
        (userinfo.fjqx != null &&
          (userinfo.fjqx.indexOf("3") != -1 ||
            userinfo.fjqx.indexOf("4") != -1))
      ) {
        companyCode = "-1";
      } else {
        companyCode = userinfo.companyCode;
      }
      if (userinfo.companyCode == "G065") {
        companyCode = "-1";
      }
      findByUserIdCompanyTree(companyCode).then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.options = this.getTreeData(data);
        }
      });
    },
    getTreeData(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].zcompany.length < 1) {
          // 最后一级没有数据将children变成undefined
          data[i].zcompany = undefined;
        } else {
          // children不为空时继续调用该方法
          this.getTreeData(data[i].zcompany);
        }
      }
      return data;
    },
    //分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      //contentdata是所有的数据，是一个大数组。使用.slice()方法可以将大数组切分
      //.slice()方法接受两个参数，开始和结束的值
      //这样得到的currentdata就是固定只有10个值的数组了，就可以用v-for展示啦
      this.allocationData = this.data.slice(
        (this.pageIndex - 1) * this.pagesize,
        this.pageIndex * this.pagesize
      );
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.allocationData = this.data.slice(
        (this.pageIndex - 1) * this.pagesize,
        this.pageIndex * this.pagesize
      );
    },
    findLable() {
      findByModule("调拨管理").then(datas => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.lable = data;
        }
      });
    },
  },
  created() {
    this.findLable();
    this.findAll();
    this.getCompanyTree();
    var userinfo = JSON.parse(localStorage.getItem("user"))
    var arr = userinfo.role.menuId.split(",");
    arr.forEach((i) => {
      if (i == "84") {
        this.show.sh = true;
      }
    })
  }
};
</script>
<style >
.el-checkbox__inner {
    border: 1px solid #606266!important;
}
</style>
<style >
.btn {
  float: left;
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/allocation/Transfer.vue